var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"not-found"},[_c('img',{attrs:{"src":require('./404_illustration@2x.png'),"width":"344px","height":"323px","alt":"404 illustration"}}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner"},[_c('span',[_vm._v("Page Not Found")]),_c('p',{staticClass:"info"},[_vm._v("The page you are looking for doesn’t seem to exist…")])])
}]

export { render, staticRenderFns }